const es = {
  firstDayWeek: 'Primer día de la semana',
  startScreen: 'Pantalla de inicio',
  blackTheme: 'Tema negro',
  backgroundImage: 'Imagen de fondo',
  language: 'Idioma',
  sounds: 'Sonidos',
  home: 'Casa',
  calendar: 'Calendario',
  settings: 'Ajustes',
  noTasks: 'Sin tareas',
  myTasks: 'Mis tareas',
  chooseImage: 'Seleccione una foto de fondo:',
  saveChanges: 'Guardar cambios',
  edit: 'Editar',
  add: 'Añadir',
  close: 'CERRAR',
  taskManager: 'Administrador de tareas'
};

export default es;
